import { useEffect } from 'react';
import _get from 'lodash/get';
import { useNavigation } from '@/processes/Router';
import BTCLandingBlocks from './btc/LandingBlocks';
import RVNLandingBlocks from './rvn/LandingBlocks';
import ETCLandingBlocks from './etc/LandingBlocks';
import KASLandingBlocks from './kas/LandingBlocks';
import DNXLandingBlocks from './dnx/LandingBlocks';
import GRAMLandingBlocks from './gram/LandingBlocks';
import LTCLandingBlocks from './ltcbtc/LandingBlocks';
import { DiscountRequestModal, HostingRequestModal } from '~/marketing';

const LANDING_BLOCKS = {
  BTC: BTCLandingBlocks,
  RVN: RVNLandingBlocks,
  ETC: ETCLandingBlocks,
  KAS: KASLandingBlocks,
  DNX: DNXLandingBlocks,
  GRAM: GRAMLandingBlocks,
  LTCBTC: LTCLandingBlocks,
}

const Landing = () => {
  useEffect(() => {
    const body = document.querySelector("body");
    if (body) {
      body.className = 'landing';
    }
    return () => {
      if (body) { body.className = ''; }
    }
  }, []);

  const { coin } = useNavigation();
  const Blocks = _get(LANDING_BLOCKS, coin);
  return (
    <>
      {Blocks && <Blocks/>}
      <DiscountRequestModal />
      <HostingRequestModal />
    </>
  );
}

export default Landing;
